// Canonical shared Firestore collections for the Brugo ecosystem.
// Customer App (brugo-home), Professional + Field App, and this Operations
// Portal all read/write these SAME collections. No separate CRM schema.
// `projects` is the SINGLE source of truth for the pre-hire/request lifecycle.
export const COLLECTIONS = {
  users: "users",
  professionals: "professionals",
  categories: "categories",
  products: "products",
  projects: "projects",                          // pre-hire lifecycle lives here
  leads: "leads",
  professionalResponses: "professional_responses", // top-level mirror of projects.responses[]
  consultations: "consultations",                  // top-level mirror of projects.consultation
  payments: "payments",
  orders: "orders",
  materialLists: "material_lists",
  notifications: "notifications",
  disputes: "disputes",
  auditLogs: "audit_logs",
  config: "config",                                 // config/promise, config/app_settings
  connectionTest: "__firebase_connection_test",
};

// Pre-hire → delivery lifecycle statuses on a `projects` document.
export const PROJECT_STATUS = {
  REQUESTED: "requested",       // customer created (Customer App)
  OPS_REVIEW: "ops_review",     // Ops validated
  LEADS_RELEASED: "leads_released", // eligible for Professional App
  RESPONDING: "responding",     // pros responding
  MATCHED: "matched",           // professional assigned
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  ON_HOLD: "on_hold",
};

// Statuses the Professional App treats as eligible pre-hire records in `projects`.
export const PREHIRE_ELIGIBLE = [
  PROJECT_STATUS.LEADS_RELEASED,
  PROJECT_STATUS.RESPONDING,
];
